import { groupBy } from 'lodash';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import ListViewHRMaster from './ListViewEmployee';
import LynIcon from 'components/@extended/LynIcon';
import plusIcon from 'assets/images/icons/plus.svg';
import TabPanel from 'components/TabPanel/TabPanel';
import comptroller from 'assets/images/comptroller_white.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { a11yProps, TabsItemFour as TabsItem } from 'pages/globals/global';
import { Box, Button, Grid, Stack, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { useGetCompanyAllMutation, useGetEmployeeListByCompanyCodeMutation } from 'store/features/process/processApi';

const HRMaster = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [reloadTable, setReloadTable] = useState(false);
	const [hrEmployeeList, setHrEmployeeList] = useState([]);
	const [activeCreateButton, setActiveCreateButton] = useState(true);
	const [selectedTab, setSelectedTab] = useState(() => {
		const activeTab = searchParams.get('tab');

		if (activeTab) {
			const index = TabsItem?.findIndex((item) => item?.label === activeTab);

			if (index > -1) return index;
		}

		return 0;
	});

	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

	const { profileData = {} } = useSelector((state) => state.profile);

	const [GetCompanyAll, { data: dataGetCompanyAll }] = useGetCompanyAllMutation();
	// const [GetPositionList, { data: OrgStructureList }] = useGetPositionListMutation();
	const [GetEmployeeListByCompanyCode, { data: employeeList, isLoading }] = useGetEmployeeListByCompanyCodeMutation();

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);

		const tabName = TabsItem?.[newValue]?.label;

		navigate(`/static/employee?tab=${tabName}`, { replace: true });
	};

	useEffect(() => {
		setActiveCreateButton(isLoading);
	}, [isLoading]);

	// useEffect(() => {
	//   if (profileData) {
	//     GetPositionList({
	//       entityParentCode: profileData?.creatorOrganizationId,
	//       entityCode: profileData?.userId,
	//     });
	//   } //eslint-disable-next-line
	// }, [profileData]);

	useEffect(() => {
		GetCompanyAll({});
	}, [GetCompanyAll]);

	useEffect(() => {
		if (profileData) {
			GetEmployeeListByCompanyCode({
				parentCode: profileData?.creatorOrganizationId,
			});
		} //eslint-disable-next-line
	}, [profileData, reloadTable]);

	useEffect(() => {
		if (employeeList && employeeList?.length) {
			const arr1 = groupBy(employeeList, 'activationStatus');

			arr1['All'] = employeeList ?? [];
			arr1['Inactive'] = employeeList?.filter((item) => item?.activationStatus === 'Inactive' || item?.activationStatus === null) ?? [];

			setHrEmployeeList(arr1);
		}
	}, [employeeList]);

	useEffect(() => {
		const activeTab = searchParams.get('tab');

		if (activeTab) {
			const index = TabsItem?.findIndex((item) => item?.label === activeTab);

			if (index < 0) return navigate('/static/employee', { replace: true });
		}
		// eslint-disable-next-line
	}, []);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<Box
					sx={{
						width: '100%',
						borderRadius: 1,
					}}
				>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						sx={{
							bgcolor: '#214689',
							px: '15px',
							py: '12px',
							color: 'common.white',
						}}
						style={{ borderRadius: '6px 6px 0 0' }}
					>
						<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
							<img alt="comptroller" src={comptroller} width="18px" height="18px" />
							<Typography variant="h4">Employees</Typography>
						</Stack>

						<Button
							type="primary"
							disabled={activeCreateButton}
							onClick={() =>
								navigate('/static/employee/create', {
									state: { OrgStructureList: dataGetCompanyAll, employeeTableList: hrEmployeeList },
								})
							}
							sx={{
								color: 'white',
								display: 'flex',
								fontWeight: 450,
								boxShadow: 'none',
								padding: '3px 15px',
								alignItems: 'center',
								transition: 'all 0.3s',
								backgroundColor: activeCreateButton ? 'gray' : theme.palette.lynTheme.success,
								border: `1px solid ${activeCreateButton ? 'gray' : theme.palette.lynTheme.success}`,
								borderColor: '#ffff',

								'&:hover': {
									backgroundColor: activeCreateButton ? 'gray' : '#207f3b',

									transform: 'scale(0.9)',
								},
							}}
						>
							<img src={plusIcon} alt="add" width="12" height="12" style={{ marginRight: '8px' }} />
							Create
						</Button>
					</Stack>

					<Box sx={{ width: '100%', backgroundColor: 'white' }} style={{ borderRadius: '0px 0px 6px 6px' }}>
						<Tabs
							value={selectedTab}
							sx={{
								'& .MuiTabs-indicator': {
									backgroundColor: '#214689',
									borderRadius: '0px 0px 0px 6px',
								},
								'& .Mui-selected': {
									color: '#214689',
								},

								'& .MuiTab-root': {
									backgroundColor: 'white',
									opacity: 1,
								},
							}}
							scrollButtons
							textColor="inherit"
							allowScrollButtonsMobile
							onChange={selectTabHandler}
							aria-label="basic tabs example"
							variant={matchDownSM ? 'scrollable' : 'standard'}
						>
							<Tab
								key="Active"
								label="Active"
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName="active" format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									// padding: "5px 50px",
									width: '176px',
								}}
								{...a11yProps(0)}
							/>
							<Tab
								key="W-I-P"
								label="W-I-P"
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName="inactive" format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									// padding: "5px 50px",
									width: '176px',
								}}
								{...a11yProps(1)}
							/>
							<Tab
								key="Inactive"
								label="Inactive"
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName="deactivated" format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									// padding: "5px 50px",
									width: '176px',
								}}
								{...a11yProps(2)}
							/>
							<Tab
								key="All"
								label="All"
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName="all" format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									// padding: "5px 50px",
									width: '176px',
								}}
								{...a11yProps(3)}
							/>
						</Tabs>
					</Box>
				</Box>

				{TabsItem?.map((item, index) => (
					<TabPanel key={index} value={selectedTab} index={index} sx={{ height: 'calc(100% - 38px)' }}>
						<Box sx={{ mt: 2 }}>
							<ListViewHRMaster
								setReloadTable={setReloadTable}
								setSelectedTab={setSelectedTab}
								isLoading={isLoading}
								OrgStructureList={dataGetCompanyAll}
								hrEmployeeList={hrEmployeeList[item?.data] ? hrEmployeeList[item?.data] : []}
							/>
						</Box>
					</TabPanel>
				))}
			</Grid>
		</Grid>
	);
};
export default HRMaster;
